<template>
    <ul class="sidebar-nav">
        <li class="nav-label mg-b-15">Menu</li>
        
        <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'dashboard' }">
                <i data-feather="home"></i> Dashboard
            </router-link>
        </li>

        <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'fx-rates' }">
                <i data-feather="bar-chart-2"></i> FX Rates
            </router-link>
        </li>

        <li class="nav-item" :class="[ currentPage.includes('portfolios') ? 'show' : '']">
            <a href="" class="nav-link with-sub">
                <i data-feather="folder"></i> Portfolios
            </a>
            <nav class="nav" aria-label="portfolio actions">
                <router-link :to="{ name: 'portfolios.create' }" exact>Create Portfolio</router-link>
                <router-link :to="{ name: 'portfolios.manage' }" :class="[$route.name === 'portfolios.show' ? 'active' : '']" exact>Manage Portfolios</router-link>
            </nav>
        </li>

        <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'requests.manage' }">
                <i data-feather="message-square"></i> Requests
            </router-link>
        </li>

        <!-- <li class="nav-item" :class="[ currentPage.includes('fees') ? 'show' : '']">
            <a href="" class="nav-link with-sub">
                <i data-feather="percent"></i> Fees
            </a>
            <nav class="nav">
                <router-link :to="{ name: 'fees.new' }" exact>New Fee</router-link>
                <router-link :to="{ name: 'fees.upload' }" exact>Upload Fees</router-link>
                <router-link :to="{ name: 'fees.manage' }" :class="[$route.name === 'fees.show' ? 'active' : '']" exact>Manage Fees</router-link>
            </nav>
        </li> -->

        <li class="nav-item" :class="[ currentPage.includes('transactions') ? 'show' : '']">
            <a href="" class="nav-link with-sub">
                <i data-feather="credit-card"></i> Transactions
            </a>
            <nav class="nav" aria-label="transactions actions">
                <router-link :to="{ name: 'transactions.new' }" exact>New Transaction</router-link>
                <router-link :to="{ name: 'transactions.upload' }" exact>Upload Transactions</router-link>
                <router-link :to="{ name: 'transactions.manage' }" :class="[$route.name === 'transactions.show' ? 'active' : '']" exact>Manage Transactions</router-link>
            </nav>
        </li>

        <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'documents' }">
                <i data-feather="file-text"></i> Documents
            </router-link>
        </li>

        <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'messages' }">
                <i data-feather="message-circle"></i> Messages
            </router-link>
        </li>

        <li class="nav-item">
            <a href="" class="nav-link with-sub">
                <i data-feather="clipboard"></i> Policies
            </a>
            <nav class="nav" aria-label="policy actions">
                <router-link :to="{ name: 'policies.new' }" exact>New Policy</router-link>
                <router-link :to="{ name: 'policies.manage' }" :class="[$route.name === 'policies.show' ? 'active' : '']" exact>Manage Policies</router-link>
            </nav>
        </li>

        <li class="nav-item" :class="[ currentPage.includes('companies') ? 'show' : '']">
            <a href="" class="nav-link with-sub">
                <i data-feather="users"></i> Companies
            </a>
            <nav class="nav" aria-label="company actions">
                <!-- <router-link :to="{ name: 'companies.new' }" exact>Create New Company</router-link>
                <router-link :to="{ name: 'companies.attach-user' }" exact>Attach User</router-link> -->
                <router-link :to="{ name: 'companies.manage' }" :class="[$route.name === 'companies.show' ? 'active' : '']" exact>Manage Companies</router-link>
                <router-link :to="{ name: 'companies.attach-user' }"  exact>Attach User</router-link>
            </nav>
        </li>
    </ul>
</template>

<script>
	export default {
		computed: {
			currentPage() {
				return this.$route.path;
			}
		}
	};
</script>